import axios from 'helpers/axios';

export const getCurrencies = async () => {
    const { data } = await axios.get('/api/adminapi/currencies/');

    return data;
};
